export default __webpack_public_path__ + "static/media/dance.eef1dfd4.png";